/**
 * Sends a freshly-authenticated marketing-site visitor into the app. `PlanGateModal`'s default
 * `onLogin` in planGate.tsx calls this.
 *
 * Its own file rather than an inline `window.location.assign` in planGate.tsx: jsdom's
 * `window.location` can be neither redefined nor spied on (the same trap `PlanGate.storeUrl`'s
 * own doc comment names, and that `blockRegistry.test.tsx` hits too), so a test that wants to
 * assert "navigated" has nothing to spy on if the call sits inline. Pulling it into a named
 * module gives `jest.mock` a seam instead.
 *
 * `window.location.assign`, not `history.push`: `/home` is an app route, and the marketing
 * router (`marketingRoutes.tsx`) has no entry for it — same reasoning as the `/discover` hubs'
 * own logged-in redirect (`DiscoverCountryPage.tsx`'s `handlePlanClick`, 123yb692mta).
 */
export function navigateToApp(): void {
	window.location.assign("/home");
}

/**
 * The same hop for a visitor who was already signed in when a marketing page loaded
 * (HomeMarketing's redirect). `replace`, not `assign`: Back must not return to `/` only to
 * bounce straight into the app again. A named export for the same jsdom reason as above.
 */
export function replaceWithAppRoute(path: "/home" | "/onboarding"): void {
	window.location.replace(path);
}

export default navigateToApp;
